module.exports = __webpack_public_path__ + "img/Lotus.696eafcd.png";